import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { getAPI, reinitialiseAPI } from 'store/apiReducer';
import * as PropTypes from 'prop-types';
import {
    Alert,
    AlertDescription,
    Col,
    Container,
    InputControl,
    Row,
    SegmentLoader,
} from '@design-system-etat/dsfr-react';
import { useHistory } from 'react-router-dom';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_DEROULE_ARME_RATELIER,
    API_GET_RECHERCHE_ARMES,
    API_RECUPERER_QUOTA,
    CONTEXT_API_RECUPERER_QUOTA,
    CONTEXT_DEROULE_ARME_RATELIER,
    CONTEXT_FICHE_SITUATION_ARME,
    CONTEXT_GET_RECHERCHE_ARMES,
} from '../../../../constants/apiUrls.constants';
import {
    LIBELLE_A_CORRIGER,
    setTableauStatutsArmes,
} from '../../../../components/arme/statuts/StatutsArmes';
import { getPath } from '../../../../utils/router';
import ModaleInformationArme from './composantsRefonte/ModaleInformationArme';
import ModalePerteVol from './components/PerdueVolee/ModalePerteVol';
import RoutesSignalerArmePerdueVolee from '../../armes/signaler-perte-vol/routes';
import ModaleValiderAcquisition from './components/ValiderAcquisition/ModaleValiderAcquisition';
import AffichageResponsive from '../../../../components/Commun/AffichageResponsive';
import CarteAffichageArme from './composantsRefonte/CarteAffichageArme';
import TableauRatelier from './TableauRatelier';

const Armes = ({ getApi, reinitialiseApi, data, dataQuota, isLoading }) => {
    const [modaleInformationsArme, setModaleInformationsArme] = useState(false);
    const [modalePerteVol, setModalePerteVol] = useState(false);
    const [modaleValiderAcquisition, setModaleValiderAcquisition] = useState(false);

    useEffect(() => {
        getApi(usagerClientReducer, API_GET_RECHERCHE_ARMES, CONTEXT_GET_RECHERCHE_ARMES);

        getApi(usagerClientReducer, API_RECUPERER_QUOTA, CONTEXT_API_RECUPERER_QUOTA);
        return () => reinitialiseApi(CONTEXT_API_RECUPERER_QUOTA);
    }, []);

    const alertNombreArmesACorriges = useMemo(() => {
        const nombreArmesACorriges = data?.records.filter(
            (armes) => armes.statut === LIBELLE_A_CORRIGER,
        ).length;

        if (nombreArmesACorriges === 1) {
            return (
                <>
                    <Alert severity="warning" role="alert" size="md">
                        <AlertDescription>
                            {nombreArmesACorriges} arme nécessite une mise à jour de votre part
                        </AlertDescription>
                    </Alert>
                </>
            );
        }
        if (nombreArmesACorriges >= 2) {
            return (
                <>
                    <Alert severity="warning" role="alert" size="md">
                        <AlertDescription>
                            {nombreArmesACorriges} armes nécessitent une mise à jour de votre part
                        </AlertDescription>
                    </Alert>
                </>
            );
        }
        return <></>;
    }, [data?.records]);

    const [armeSelectionnee, setArmeSelectionnee] = useState(undefined);

    const ouvrirModale = (arme) => {
        setModaleInformationsArme(true);
        setArmeSelectionnee(arme);
    };

    const history = useHistory();

    const etape2PerteVol = () => {
        const armesSelectionneeUuid = armeSelectionnee?.uniquid;

        if (armesSelectionneeUuid) {
            history.push({
                pathname: getPath(RoutesSignalerArmePerdueVolee),
                state: { listeArme: [armesSelectionneeUuid] },
            });
        }
    };

    useEffect(() => {
        if (armeSelectionnee?.uniquid) {
            getApi(
                usagerClientReducer,
                API_GET_DEROULE_ARME_RATELIER + armeSelectionnee.uniquid,
                CONTEXT_DEROULE_ARME_RATELIER,
            );
        }
        reinitialiseApi(CONTEXT_FICHE_SITUATION_ARME);
    }, [armeSelectionnee]);

    const [champRecherche, setChampRecherche] = useState('');

    const dataFiltrees = useMemo(() => {
        return (data && data.records ? setTableauStatutsArmes(data.records, true) : []).filter(
            (arme) =>
                arme?.numeroEncodage?.toLowerCase().includes(champRecherche) ||
                arme?.marque?.toLowerCase().includes(champRecherche) ||
                arme?.modele?.toLowerCase().includes(champRecherche) ||
                arme?.classement?.toLowerCase().includes(champRecherche) ||
                arme?.regimeDetention?.toLowerCase().includes(champRecherche) ||
                arme?.statut?.toLowerCase().includes(champRecherche) ||
                arme?.type?.toLowerCase().includes(champRecherche) ||
                arme?.calibreCanon?.toLowerCase().includes(champRecherche),
        );
    }, [data, champRecherche]);

    return (
        <>
            <Row gutters>
                {data?.nombreTotal ? (
                    <Col col={12}>
                        <p>
                            Votre râtelier comprend {data.nombreTotal} armes
                            {dataQuota && (
                                <>
                                    {' '}
                                    dont armes soumis à quota : {dataQuota.decompteActuel} /{' '}
                                    {dataQuota.quotaAutorise}
                                </>
                            )}
                        </p>
                    </Col>
                ) : (
                    <Col col={12}>
                        <p>Votre râtelier ne contient aucune arme.</p>
                    </Col>
                )}
            </Row>

            <Row gutters>{alertNombreArmesACorriges}</Row>
            <SegmentLoader isLoading={isLoading} taille="md">
                <AffichageResponsive
                    pointDeRupture="xl"
                    composantDesktop={
                        <>
                            <Col col={6}>
                                <InputControl
                                    id="filtreArme"
                                    name="filtreArme"
                                    label="Rechercher une arme"
                                    onChange={(e) => {
                                        setChampRecherche(e.target.value.toLowerCase());
                                    }}
                                />
                            </Col>
                            <TableauRatelier armes={dataFiltrees} ouvrirModale={ouvrirModale} />
                        </>
                    }
                    composantMobile={
                        <>
                            <Col col={6}>
                                <InputControl
                                    id="filtreArme"
                                    name="filtreArme"
                                    label="Rechercher une arme"
                                    onChange={(e) => {
                                        setChampRecherche(e.target.value.toLowerCase());
                                    }}
                                />
                            </Col>

                            <Container fluid={false}>
                                <Row className="liste-resultats-mobile">
                                    {dataFiltrees.map((arme) => (
                                        <CarteAffichageArme
                                            arme={arme}
                                            setModaleInformationsArme={setModaleInformationsArme}
                                            setArmeSelectionnee={setArmeSelectionnee}
                                        />
                                    ))}
                                </Row>
                            </Container>
                        </>
                    }
                />
            </SegmentLoader>

            <>
                {modaleInformationsArme && (
                    <ModaleInformationArme
                        arme={armeSelectionnee}
                        fermerModale={() => setModaleInformationsArme(false)}
                        ouvrirModalePerteVol={() => setModalePerteVol(true)}
                        ouvrirModaleValiderAcquisition={setModaleValiderAcquisition}
                    />
                )}
                {modalePerteVol && (
                    <ModalePerteVol
                        fermerModale={() => {
                            setModalePerteVol(false);
                            setModaleInformationsArme(true);
                        }}
                        etape2PerteVol={etape2PerteVol}
                    />
                )}
                {modaleValiderAcquisition && (
                    <ModaleValiderAcquisition
                        armesSelectionnees={[armeSelectionnee]}
                        fermerModale={() => {
                            setModaleValiderAcquisition(false);
                            getApi(
                                usagerClientReducer,
                                API_GET_RECHERCHE_ARMES,
                                CONTEXT_GET_RECHERCHE_ARMES,
                            );
                        }}
                    />
                )}
            </>
        </>
    );
};

Armes.propTypes = {
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    data: PropTypes.shape({
        nombreTotal: PropTypes.number.isRequired,
        records: PropTypes.array,
    }),
    dataQuota: PropTypes.shape({
        decompteActuel: PropTypes.number.isRequired,
        quotaAutorise: PropTypes.number.isRequired,
    }),
    isLoading: PropTypes.bool,
};

export default connect(
    (state) => {
        const { data: dataQuota } = state.monCompte.recupererQuota;
        const { data, isLoading } = state.recherche.armes;
        return {
            data,
            dataQuota,
            isLoading,
        };
    },
    {
        getApi: getAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(Armes);
